import React, { useEffect, useRef } from "react";
import styles from "./index.module.scss";
export var Search = function (props) {
    var input = useRef(null);
    useEffect(function () {
        if (!props.visible)
            return;
        setTimeout(function () {
            var _a;
            (_a = input.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    }, [props.visible, input]);
    return React.createElement("input", { ref: input, className: styles.search, placeholder: "Rechercher", "custom-visible": props.visible.toString(), value: props.content, onChange: function (e) { return props.onChange(e.target.value); }, onKeyPress: function (e) {
            var _a;
            if (e.key === "Enter")
                (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props);
        } });
};
